import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/user-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M19.0001 21C19.0001 19.5317 18.9895 19.019 18.8712 18.6289C18.5803 17.6702 17.8299 16.9198 16.8712 16.6289C16.4811 16.5106 15.9684 16.5 14.5001 16.5H9.50009C8.03177 16.5 7.51906 16.5106 7.129 16.6289C6.17031 16.9198 5.41986 17.6702 5.129 18.6289C5.01067 19.019 5.00009 19.5317 5.00009 21C5.00009 21.5523 4.55238 22 4.00009 22C3.44781 22 3.00009 21.5523 3.00009 21C3.00009 19.6774 2.98889 18.7943 3.21493 18.0488C3.69969 16.4508 4.95092 15.1996 6.54892 14.7148C7.29437 14.4888 8.17749 14.5 9.50009 14.5H14.5001C15.8227 14.5 16.7058 14.4888 17.4513 14.7148C19.0493 15.1996 20.3005 16.4508 20.7852 18.0488C21.0113 18.7943 21.0001 19.6774 21.0001 21C21.0001 21.5523 20.5524 22 20.0001 22C19.4478 22 19.0001 21.5523 19.0001 21ZM15.5001 7.5C15.5001 5.567 13.9331 4 12.0001 4C10.0671 4 8.50009 5.567 8.50009 7.5C8.50009 9.433 10.0671 11 12.0001 11C13.9331 11 15.5001 9.433 15.5001 7.5ZM17.5001 7.5C17.5001 10.5376 15.0377 13 12.0001 13C8.96252 13 6.50009 10.5376 6.50009 7.5C6.50009 4.46243 8.96252 2 12.0001 2C15.0377 2 17.5001 4.46243 17.5001 7.5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as User01Icon };
